import React, { useState } from "react";
import {
  Container,
  Tabs,
  Tab,
  Row,
  Col,
  Spinner,
  Modal,
} from "react-bootstrap";
import useSharedBucketList from "./useSharedBucketList";
import Header from "../../Common/Header";
import "./SharedBucketList.scss";
import Footer from "../../Common/Footer/Footer";
import EmptyFeedCard from "../../../_uiComponents/EmptyFeedCard";
import MainLayout from "../../Common/MainLayout";
export default (props) => {
  const { loading, allbucketList, onViewClick } = useSharedBucketList();

  return (
    <MainLayout pageName={"Shared Bucket List"}>
      <Container className="footer-gap">
        <div className="applied-job-board">
          <div className="d-flex align-items-center my-3 pb-3 justify-content-between">
            <h4 className="text-uppercase mr-4 text-nowrap">
              Shared Bucket List
            </h4>
            {/* <div className="text-right">
              <button className="btn btn-light mr-3"><FontAwesomeIcon icon={faShareNodes} className="mr-2" />Share</button>
            </div> */}
          </div>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : Array.isArray(allbucketList) && allbucketList.length ? (
            <div className="row">
              {Array.isArray(allbucketList) &&
                allbucketList.map((item) => (
                  <div className="col-lg-6 col-md-6 mb-4">
                    <div className="p-4 bg-white border position-relative h-100 rounded-lg shadow-2">
                      <div className="upper border-bottom">
                        <div className="d-flex mb-3 ">
                          <div className="job-info">
                            <h3 className="font-weight-medium mb-1 text-capitalize text-primary">
                              {item?.bucket_list_details &&
                                item.bucket_list_details?.title}
                            </h3>
                          </div>
                        </div>

                        <div className="d-flex align-items-center fs-smallest mb-3 justify-content-between">
                          <div>
                            <p className="mb-0 text-capitalize font-weight-medium mr-2">
                              Number of candidates:{" "}
                              <span className="text-grey-4 font-weight-400">
                                {item?.bucket_list_details &&
                                  item.bucket_list_details?.total_candidates}
                              </span>
                            </p>
                            <p className="font-weight-medium mb-2">
                              AssessmentKits:
                              {Array.isArray(
                                item?.bucket_list_details &&
                                  item.bucket_list_details
                                    ?.assigned_assessments_details
                              ) &&
                                item?.bucket_list_details &&
                                item.bucket_list_details
                                  ?.assigned_assessments_details &&
                                item.bucket_list_details.assigned_assessments_details.map(
                                  (i) => (
                                    <span className="text-grey-4 ml-2 font-weight-normal">
                                      {i?.title},
                                    </span>
                                  )
                                )}
                            </p>
                            <p className="mb-0 text-capitalize font-weight-medium mr-2">
                              Shared By:{" "}
                              <span className="text-grey-4 font-weight-400">
                                {item?.bucket_list_details &&
                                  item.bucket_list_details
                                    ?.created_by_details &&
                                  item.bucket_list_details.created_by_details
                                    ?.full_name}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mt-3 flex-md-wrap flex-lg-nowrap">
                        <div className="job-bottom ml-auto mt-0 mt-md-3 mt-lg-0">
                          <button
                            className="btn btn-primary py-2 mr-2 text-nowrap"
                            onClick={() =>
                              onViewClick(
                                item?.bucket_list_details &&
                                  item.bucket_list_details?.id
                              )
                            }
                          >
                            View
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <EmptyFeedCard message="No Shared Bucket List Found" />
          )}
        </div>
      </Container>
      <Footer />
    </MainLayout>
  );
};
